import React, { useMemo } from 'react';
import { useQuery } from 'react-query';
import { getEvent } from '@src/api/manualAlerts';
import { get, isEmpty } from 'lodash';
import { createAlertSummary, parseAlert } from './utils';
import { trackQueryError } from '@utils/sensor/apptracker';

const defaultValue = null;

// fetch details of a single event
// if you need raw event data pass an onSelect and keep current one as default
function useFetchEvent({ eventId, enabled = true }) {
  // stale time prevents redundant calls from multiple subscribers
  const {
    data: response,
    dataUpdatedAt,
    isFetching,
    isError,
  } = useQuery(
    ['manual-alert-event', eventId],
    () => {
      return getEvent(eventId, { params: {} }).then((response) => {
        return get(response, ['data'], {});
      });
    },
    {
      retry: 3,
      refetchOnWindowFocus: false,
      enabled: enabled && !!eventId,
      staleTime: 5 * 60 * 1000, // 5m
      placeholderData: defaultValue,
      onError: (err) => {
        trackQueryError({ type: 'manual-alert-event-details', err });
      },
    },
  );

  const data = useMemo(() => {
    if (!isEmpty(response)) {
      const alert = parseAlert(response.alert);
      return createAlertSummary(response, alert);
    }
    return defaultValue;
  }, [response]);

  return { data, dataUpdatedAt, isFetching, isError };
}

export default useFetchEvent;
